import React from "react";
import "./Testmonials.css";
import pers from "../../assets/avatar1.jpg";

// import Swiper core and required modules
import { Pagination } from "swiper";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

const data = [
  {
    person: pers,
    name: "Mayank Kumar",
    review:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Iusto fuga culpa delectus soluta accusantium laboriosam, doloribus, alias ipsam magnam facere error assumenda eius mollitia reprehenderit esse? Eaque ut exercitationem minima.",
  },
  {
    person: pers,
    name: "Mayank Kumar",
    review:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Iusto fuga culpa delectus soluta accusantium laboriosam, doloribus, alias ipsam magnam facere error assumenda eius mollitia reprehenderit esse? Eaque ut exercitationem minima.",
  },
  {
    person: pers,
    name: "Mayank Kumar",
    review:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Iusto fuga culpa delectus soluta accusantium laboriosam, doloribus, alias ipsam magnam facere error assumenda eius mollitia reprehenderit esse? Eaque ut exercitationem minima.",
  },
  {
    person: pers,
    name: "Mayank Kumar",
    review:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Iusto fuga culpa delectus soluta accusantium laboriosam, doloribus, alias ipsam magnam facere error assumenda eius mollitia reprehenderit esse? Eaque ut exercitationem minima.",
  },
  {
    person: pers,
    name: "Mayank Kumar",
    review:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Iusto fuga culpa delectus soluta accusantium laboriosam, doloribus, alias ipsam magnam facere error assumenda eius mollitia reprehenderit esse? Eaque ut exercitationem minima.",
  },
  {
    person: pers,
    name: "Mayank Kumar",
    review:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Iusto fuga culpa delectus soluta accusantium laboriosam, doloribus, alias ipsam magnam facere error assumenda eius mollitia reprehenderit esse? Eaque ut exercitationem minima.",
  },
];

const Testmonials = () => {
  return (
    <section id="testmonial">
      <h5>Review from Clients</h5>
      <h2>Testimonials</h2>

      <Swiper
        className="container testimonials"
        modules={[Pagination]}
        spaceBetween={40}
        slidesPerView={1}
        pagination={{ clickable: true, dynamicBullets: true }}
        autoplay={{ delay: 1000, disableOnInteraction: false }}
      >
        {data.map(({ person, name, review }, index) => {
          return (
            <SwiperSlide key={index} className="testimonial">
              <div className="client__avatar">
                <img src={person} alt="" />
              </div>
              <h5>{name}</h5>
              <small className="client__review">{review}</small>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </section>
  );
};

export default Testmonials;
